import { useState } from "react";
import { cn } from "../../../../../../lib/utils";
import { ActivityPosition } from "../../types";
import { ActivityDetailsModal } from "../../../../../ActivityDetailsModal";

interface ActivityItemProps {
  activity: ActivityPosition;
  top: number;
  height: number;
  width: number;
  left: number;
}

export default function ActivityItem({
  activity,
  top,
  height,
  width,
  left,
}: ActivityItemProps) {
  const [displayDetails, setDisplayDetails] = useState(false);

  return (
    <>
      <ActivityDetailsModal
        activityId={activity.id}
        eventId={activity.eventId ?? null}
        isOpen={displayDetails}
        onClose={() => setDisplayDetails(false)}
      />

      <div
        onClick={() => setDisplayDetails(!displayDetails)}
        className={cn(
          "absolute text-white text-xs rounded-xs px-1 truncate font-medium border-l-5 cursor-pointer transition-all duration-200"
        )}
        style={{
          borderLeftColor: activity.color,
          backgroundColor: `${activity.color}80`,
          top: `${top}%`,
          height: `${height}%`,
          width: `${width}%`,
          left: `${left}%`,
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = activity.color;
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = `${activity.color}80`;
        }}
      >
        {activity.title}
      </div>
    </>
  );
}
